// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getDatabase } from "firebase/database";

const firebaseConfig = {
  apiKey: "AIzaSyBDTFv04j8L1bJ8xby__77T2jds9-H-fNk",
  authDomain: "class-trackr.firebaseapp.com",
  databaseURL:
    "https://class-trackr-default-rtdb.asia-southeast1.firebasedatabase.app",
  projectId: "class-trackr",
  storageBucket: "class-trackr.appspot.com",
  messagingSenderId: "603217311544",
  appId: "1:603217311544:web:f782f819c2af4161bb33cd",
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const db = getDatabase(app);
export { db };
